/**
 * Selects a random item from an array
 * @param items Array of items to select from
 * @returns A randomly selected item from the array
 */
const selectRandomItem = <T>(items: T[]): T => items[Math.floor(Math.random() * items.length)]

export { selectRandomItem }
